import { createRouter } from '.'
import { useMutationObserver } from '@vueuse/core'

/**
 * Create a router for the main app using
 * window.location.
 */
export function createPartialRouter(el: HTMLElement) {
    const router = createRouter({
        getParams() {
            return String(el.dataset.options)
        },
        getQuery(params, delimiter) {
            return params.toString().split('&').join(delimiter)
        },
        pushState(query) {
            el.dataset.options = query
        }
    })

    useMutationObserver(
        el,
        ([mutation]) => {
            if (mutation.attributeName === 'data-options') {
                router.onRouteChanged()
            }
        },
        {
            attributes: true
        }
    )

    return router
}
